var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.5,
    width: 60,
    height: 60,
    rx: 7,
    fill: "#005587"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2222 40.0403C31.7591 40.0475 33.2915 39.8902 34.7867 39.5719C35.0958 39.5131 35.7079 39.0996 35.8166 38.8459L35.8333 38.7751V28.7135C35.8333 28.5499 35.7438 28.3967 35.5933 28.3037C33.4767 26.9958 31.6111 24.1215 31.6111 21.3902C31.6548 20.3912 30.8633 19.5185 29.7622 19.3513C28.68 19.217 27.2956 19.8138 26.6422 21.9025C26.4075 23.3837 26.6066 24.8941 27.22 26.2857C27.2478 26.3614 27.2334 26.4444 27.1812 26.509C27.1465 26.552 27.0978 26.5834 27.0429 26.5995L26.9567 26.612H19.9444C18.4103 26.612 17.1667 27.7252 17.1667 29.0985C17.1689 29.9939 17.7088 30.819 18.58 31.2588C18.2586 31.7897 18.1905 32.4143 18.3911 32.9908C18.5918 33.5673 19.0442 34.0468 19.6456 34.3203C19.0417 35.4195 19.5368 36.7491 20.7567 37.3041C20.5865 37.6135 20.4987 37.9539 20.5 38.2988C20.5 38.9221 20.798 39.9493 22.7376 40.0347L23 40.0403H30.2222ZM42.5635 40.6666C43.2109 40.6666 43.7451 40.2769 43.8235 39.7732L43.8334 39.645V28.407C43.8334 27.8862 43.3489 27.4564 42.7228 27.3934L42.5635 27.3854H38.4365C37.7892 27.3854 37.2549 27.7751 37.1766 28.2646L37.1667 28.3889V39.645C37.1667 40.1658 37.6511 40.5956 38.2772 40.6587L38.4365 40.6666H42.5635ZM40.5 38.3333C39.9477 38.3333 39.5 37.8856 39.5 37.3333C39.5 36.781 39.9477 36.3333 40.5 36.3333C41.0523 36.3333 41.5 36.781 41.5 37.3333C41.5 37.8856 41.0523 38.3333 40.5 38.3333Z",
    fill: "#80AAC3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.38d51ac5.svg";
export { ForwardRef as ReactComponent };